//src/pages/home.js
import React, {useState, useEffect} from 'react'
import Header from '../components/home/header';
import Footer from '../components/home/footer'; 
import { httpss } from '../utils/host';
import axios from 'axios';
import { AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from '@azure/msal-react';
import * as msal from '@azure/msal-browser';
import { loginRequest, optionRefesh, msalConfig } from '../utils/azure/config';
import { Link, useParams, Outlet, useLocation  } from 'react-router-dom';
import { msalInstance } from "../index";
import Notification from '../components/Noti/Noti'
import * as MdIcons from 'react-icons/md';
import * as FiIcons from 'react-icons/fi';
import { CiLogout } from "react-icons/ci";

export default function HomePage() {
  const location = useLocation();
  const [isMenu, setIsMenu] = useState(false)
  const [hovering, setHovering] = useState(false);
  const [selectedTab, setSelectedTab] = useState(location.pathname);
  const [login, setLogin] = useState(false);
  const { instance } = useMsal();
  
  const [notification, setNotification] = useState(null);
  const showNotification = (message) => {setNotification({ message })}
  const handleCloseNotification = () => {setNotification(null)}

  const listNavbar = [
    { 
      "slug": "/", 
      "title": "Dashboard", 
      "icon": "MdOutlineDashboard", 
      "library": MdIcons, 
      "sizeIcon":"" 
    },
    { 
      "slug": "/messenger", 
      "title": "Messenger", 
      "icon": "MdOutlineFormatListNumbered", 
      "library": MdIcons, 
      "sizeIcon":"" 
    },
    { 
      "slug": "/connected", 
      "title": "Connected", 
      "icon": "FiUsers", 
      "library": FiIcons, 
      "sizeIcon":"" 
    },
  ];

  // const handleLogin = async () => {
  //   try {
  //     const response = await msalInstance.loginPopup(loginRequest);
  //     msalInstance.setActiveAccount(response.account);
  
  //     const tokenResponse = await msalInstance.acquireTokenSilent(optionRefesh);
  //     const accessToken = tokenResponse.accessToken;
  //     sessionStorage.setItem('accessToken', accessToken);

  //   } catch (err) {
  //     console.error("Error during login or fetching user data:", err);
  //   }
  // };

useEffect(() => {
  setSelectedTab(location.pathname);
  
}, [location.pathname]);

  const handleLogOut = () => {
    sessionStorage.clear();
    window.location.reload();
  }
  return (
    <div className='bg-[#f0f0f0]'>
        <div>
          <Header isMenu={isMenu} setIsMenu={setIsMenu} />
          <div className='flex overflow-hidden bg-white'>

          <nav
  className={`fixed top-[58px] left-0 bottom-0 z-10 bg-gray-50 transition-all duration-300 border-r overflow-auto
  ${isMenu || hovering ? "w-64" : "w-16"} max-md:hidden`}
  onMouseEnter={() => setHovering(true)}
  onMouseLeave={() => setHovering(false)}
>

      {listNavbar.map((item, index) => {
        const IconComponent = item.library[item.icon];  
        return (
          <Link 
            key={index} to={item.slug}
            className={`flex gap-2 items-center mx-2 my-1 text-gray-700 hover:bg-gray-100 p-2 rounded 
            ${selectedTab === item.slug ? "bg-white shadow" : ""}`}
          >
            <p className={`shadow p-2 rounded ${selectedTab === item.slug ? "bg-[#127BBE] text-white" : ""}`}><IconComponent size={item.sizeIcon || ""} /></p>
            <p className={`${isMenu || hovering ? '' : 'hidden'} text-nowrap`}>{item.title}</p>
          </Link>
        );
      })}
      <button onClick={handleLogOut} className='w-full'>
        <div className='flex mx-2 my-1 items-center gap-2 hover:bg-gray-100 p-2'>
          <p className='shadow p-2 rounded'><CiLogout size={20}/></p>
          <p className={`${isMenu || hovering ? '' : 'hidden'} text-nowrap`}>Log Out</p>
        </div>
      </button>
    </nav>

  {/* Navbar Mobile */}
  <nav className={`${!isMenu?"hidden":""} md:hidden`}>
    <div  className='fixed z-10 overflow-auto w-full bg-gray-900/60 h-screen shadow border-r-2'>
      <div  className='fixed z-10 w-2/3 bg-gray-50 h-screen overflow-auto'>
      {listNavbar.map((item, index) => {
          const IconComponent = item.library[item.icon];  
          return (
            <Link 
              key={index} to={item.slug} 
              className={`flex gap-2 items-center m-2 text-gray-700 hover:bg-gray-100 p-2 rounded 
              ${selectedTab === item.slug ? "bg-white shadow" : ""}`}
              onClick={()=>{setIsMenu(false)}}
            >
                <p className={`shadow p-2 rounded ${selectedTab === item.slug ? "bg-[#127BBE] text-white" : ""}`}><IconComponent size={item.sizeIcon || ""} /></p>
                <p className={`text-nowrap`}>{item.title}</p>
            </Link>
          );
      })}
      <button onClick={handleLogOut} className='w-full'>
        <div className='flex mx-2 my-1 items-center gap-2 hover:bg-gray-100 p-2'>
          <p className='shadow p-2 rounded'><CiLogout size={20}/></p>
          <p className={`${isMenu || hovering ? '' : 'hidden'} text-nowrap`}>Log Out</p>
        </div>
      </button>
      </div>
    </div>
  </nav>

  <div 
  className={`w-full overflow-auto min-h-[calc(100vh-64px)] transition-all duration-300 
    ${isMenu || hovering ? "md:ml-64" : "md:ml-16"}`}
>
  <Outlet />
</div>

  </div>
        </div>
    </div>
  );
}
